import { Gender } from "@/Common/Models/Patient/PatientEnums";
import { CurvesName } from "@/Patient/Models/GrowthCharts/LoadGrowthCurvesCacheResponse";
import { VitalProperty } from "../../../Models/GrowthCharts/BaseChartModel";

export class CurveNameGetter {
    public static getChartFor(correctedAge: number, vitalProperty: VitalProperty, gender: Gender, isFenton: boolean): CurvesName {
        switch (vitalProperty) {
            case "Height":
                return this.getHeightCharts(correctedAge, gender, isFenton);
            case "Weight":
                return this.getWeightCharts(correctedAge, gender, isFenton);
            case "HeadCircumference":
                return this.getHeadCircumcereCharts(correctedAge, gender, isFenton);
            case "MassBodyIndex":
                return this.getBmiCharts(correctedAge, gender);
        }
    }

    public static getBmiCharts(age: number, gender: Gender): CurvesName {
        if (age > 2 && age <= 19) {
            return gender === Gender.Male
                ? "bmiMale2-19"
                : gender === Gender.Female
                    ? "bmiFemale2-19"
                    : null;
        }
        return null;
    }

    public static getWeightCharts(age: number, gender: Gender, isFenton: boolean): CurvesName {
        if (isFenton) {
            return gender === Gender.Male
                ? "fentonWeightMale"
                : gender === Gender.Female
                    ? "fentonWeightFemale"
                    : null;
        }
        else if (age <= 2) {
            return gender === Gender.Male
                ? "weightMale0-2"
                : gender === Gender.Female
                    ? "weightFemale0-2"
                    : null;
        }
        else if (age > 2 && age <= 19) {
            return gender === Gender.Male
                ? "weightMale2-19"
                : gender === Gender.Female
                    ? "weightFemale2-19"
                    : null;
        }
        return null;
    }

    public static getHeightCharts(age: number, gender: Gender, isFenton: boolean): CurvesName {
        if (isFenton) {
            return gender === Gender.Male
                ? "fentonLenghtMale"
                : gender === Gender.Female
                    ? "fentonLenghtFemale"
                    : null;
        }
        else if (age <= 2) {
            return gender === Gender.Male
                ? "lengthMale0-2"
                : gender === Gender.Female
                    ? "lengthFemale0-2"
                    : null;
        }
        else if (age > 2 && age <= 19) {
            return gender === Gender.Male
                ? "heightMale2-19"
                : gender === Gender.Female
                    ? "heightFemale2-19"
                    : null;
        }
        return null;
    }

    public static getHeadCircumcereCharts(age: number, gender: Gender, isFenton: boolean): CurvesName {
        if (isFenton) {
            return gender === Gender.Male
                ? "fentonHeadCircMale"
                : gender === Gender.Female
                    ? "fentonHeadCircFemale"
                    : null;
        }
        else if (age <= 5) {
            return gender === Gender.Male
                ? "headCircMale0-5"
                : gender === Gender.Female
                    ? "headCircFemale0-5"
                    : null;
        }
        return null;
    }
}
